import { createSelector } from '@reduxjs/toolkit'

export const layoutState = ({ layout }) => layout

export const loadingSelector = createSelector(
  layoutState,
  ({ isLoading }) => isLoading
)
